import React from 'react';
import { List, ListItemIcon, ListItemText, Typography, Divider, Box } from '@mui/material';
import { SidebarPaper, ListItemButton } from './SideNavBar.styles';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ menuItems, sections }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const renderItem = (item, index) => (
        <ListItemButton
            key={item.path || index}
            selected={location.pathname === item.path}
            onClick={() => navigate(item.path)}
        >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
        </ListItemButton>
    );

    if (sections) {
        return (
            <SidebarPaper elevation={3}>
                <List component="nav" disablePadding>
                    {sections.map((section, sIdx) => (
                        <Box key={section.heading}>
                            {sIdx > 0 && <Divider sx={{ my: 0.5 }} />}
                            <Typography
                                variant="overline"
                                sx={{
                                    px: 2, pt: sIdx === 0 ? 1.5 : 1, pb: 0.5,
                                    display: 'block', color: 'text.secondary',
                                    fontWeight: 700, letterSpacing: '0.08em', fontSize: '0.68rem',
                                }}
                            >
                                {section.heading}
                            </Typography>
                            {section.items.map(renderItem)}
                        </Box>
                    ))}
                </List>
            </SidebarPaper>
        );
    }

    return (
        <SidebarPaper elevation={3}>
            <List component="nav">
                {(menuItems || []).map(renderItem)}
            </List>
        </SidebarPaper>
    );
};

export default Sidebar;
